module.exports = __webpack_public_path__ + "img/plan-duo-patinete.ffd47acc.png";